export enum Locale {
  en = 'en',
  vi = 'vi'
}
